import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { toast } from 'react-toastify';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";
import { TrackingNumber } from "../../../atomic";

//Helpers
import { CopyToClipboard } from "../../../../utils/Helpers";

//Assets
import DistanceIcon from "../../../../images/distance.png";
import CopyIcon from "../../../../images/copy-icon.png";

//Interfaces
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  tracking,
  loading,
  order_id,
  refresh,
  toPickupDetails
}) => {
  const CoppHandler = () => {
    CopyToClipboard(order_id)

    toast.success(
      "Copied",
      {
        position: 'top-right',
        autoClose: 1000,
        closeOnClick: true,
        pauseOnHover: true
      },
    );
  }
  return (
    <CustomBody loading={loading}>
      <div className="pickup-location-body">
        <KickImage className="location-icon" src={DistanceIcon} alt="pickup-address" />
        <p className="title">Your Package’s Location</p>
        <p className="info">Please allow up to 3 hours to get an update of your delivery.</p>
        <p className="refresh" onClick={refresh}>Refresh</p>
        <div className="location-detail-wrapper">
          <div className="order-id-wrapper">
            <p className="order-text">Shipper Order ID</p>
            <p className="order-number">{order_id} <KickImage onClick={CoppHandler} className="copy-icon" src={CopyIcon} alt="copy" /></p>
          </div>

          <div className="location-tracking-wrapper">
            <TrackingNumber tracking={tracking} />
          </div>
        </div>
        <CustomButton
          text={"Pick-up details"}
          disabled={false}
          onClick={() => toPickupDetails()}
        />
      </div>
    </CustomBody>
  )
}

export default Component;